import React from 'react';
import PropTypes from 'prop-types';
import {HamburgerIcon} from '../../../Icons';
import {ControlButtons, ControlTooltip} from '../../../ControlTooltip';

export function PlantTooltip(props) {
  const tooltipStyle = () => {
    let position = {position: 'absolute', top: '-45px'};
    if (props.selected) {
      position = {top: '-55px'};
    }
    return position;
  };

  return (
    <ControlTooltip
      orientation='v'
      label={props.plantLabel}
      showControls={props.selected}
      tooltipStyle={tooltipStyle()}>
      <ControlButtons buttonList={props.buttonList} />
    </ControlTooltip>
  );
}

PlantTooltip.propTypes = {
  /**
   * Label for the plant
   */
  plantLabel: PropTypes.string,
  /**
   * Boolean to set if plant is selected
   */
  selected: PropTypes.bool,
};

PlantTooltip.defaultProps = {
  buttonList: [
    {
      onClick: () => {},
      image: HamburgerIcon,
    },
  ],
};
